import { useEffect, useState } from "react";
import {
  Autocomplete,
  CurrencyInput,
  FormControl,
  Grid,
  TextField,
} from "../../../components";
import { filtrosUrl, value } from "../../../helpers";
import { GrupoPessoasService } from "../../../services";
import { cacheApi, responseErros, unformatPrice } from "../../../utils";

export default function TabFornecedor({
  fornecedorSelecionado,
  linhaSelecionada,
  cacheDto,
  setCacheDto,
  inputErros
}) {
  const [listaGrupoPessoa, setListaGrupoPessoa] = useState([]);
  const [fornecedor, setFornecedor] = useState(fornecedorSelecionado);

  const grupoPessoasService = new GrupoPessoasService();

  useEffect(() => {
    buscaGruposPessoas();
  }, []);

  const buscaGruposPessoas = async () => {
    const filtros = {
      ativado: true,
      tipoPessoa: 2,
      restritiva: true,
    };
    const label = filtrosUrl.getUrl(filtros, grupoPessoasService.urlBase);
    const cacheBody = {
      apiFunction: grupoPessoasService.getAllFiltroAvancado(filtros),
      dto: { cacheDto, setCacheDto },
    };
    const res = await cacheApi(label, cacheBody);
    if (!res.isAxiosError) {
      setListaGrupoPessoa(res.data.rows);
    } else {
      responseErros(res);
    }
  };

  const handleChangeAutocomplete = (name, value) => {
    fornecedorSelecionado.setAtributo(name, value?.id);
    setFornecedor({ ...fornecedorSelecionado });
  };

  const handleInputBlur = (e) => {
    const { name, value } = e.target;
    fornecedorSelecionado.setAtributo(name, unformatPrice(value));
    setFornecedor({ ...fornecedorSelecionado });
  };

  return (
    <Grid container spacing={2} className="mt-1">
      <Grid item xs={3}>
        <FormControl variant="outlined" margin="normal" fullWidth>
          <Autocomplete
            id="grupoPessoaId"
            name="grupoPessoaId"
            options={listaGrupoPessoa}
            noOptionsText="Sem opções"
            autoHighlight
            getOptionLabel={(option) => (option.nome ? option.nome : "")}
            filterSelectedOptions
            onChange={(_, value) =>
              handleChangeAutocomplete("grupoPessoaId", value)
            }
            renderInput={(params) => (
              <TextField {...params} label="Grupos de Pessoas" />
            )}
            value={value.autoComplete(
              listaGrupoPessoa,
              fornecedor?.grupoPessoaId,
            )}
          />
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <CurrencyInput
          label="Limite de Crédito"
          name="limiteCompra"
          onBlur={handleInputBlur}
          required
          error={inputErros?.get(`[${linhaSelecionada}].fornecedor.limiteCompra`)}
          value={fornecedor?.limiteCompra ?? ""}
        />
      </Grid>
    </Grid>
  );
}
